import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.scss']
})
export class LandingpageComponent implements OnInit {

  Dashboardtext = `The City of Jacksonville has conducted an in-depth analysis of its quality of life investments based on the framework's ten goals and updated reports will be published periodically. 
  This data may not be inclusive of all the City’s investments and is only a point-in-time funding snapshot for Fiscal Years 2019-2022.`;

  CGFtext = `Successful community partnerships require alignment of resources to achieve impact. 
  The Community Goals Framework was developed, in partnership with the public, private and philanthropic sectors, 
  to create a universal language all sectors can use to measure their investments and impact. Click here to learn more.`

  Resourcestext = `Click here to access published reports and presentations on the City of
  Jacksonville’s Quality of Life investments. This page also includes
  reference resources and dashboard navigation tools, such as the Quick
  Tips Guide.`



  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  GoBacktoDashboard() {
    this.router.navigateByUrl('/dashboard');
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  GotoResourcesPage() {
    this.router.navigateByUrl('/Resources');
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }

  GotoResources() {
    window.open('https://nonprofits.coj.net/StrategicPartnerships/CommunityGoalsFramework.aspx', '_blank');
  }



}
